import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-621366a7"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "banner-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "apply-form-box"
};
var _hoisted_5 = {
  class: "page-inner-container"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "tip"
  }, [/*#__PURE__*/_createElementVNode("span", null, "提示：报名信息请认真填写，若填写错误，影响范围："), /*#__PURE__*/_createElementVNode("span", null, "1.用户无法进入答题系统；"), /*#__PURE__*/_createElementVNode("span", null, "2.用户无法晋级下一轮活动；"), /*#__PURE__*/_createElementVNode("span", null, "3.用户的活动证书信息错误。")], -1);
});
var _hoisted_7 = {
  key: 1,
  class: "module-bottom-wrap"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "status-img"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "//img.hetao101.com/assets/ug-fe-contest/mobile/note-error.png",
    alt: ""
  })], -1);
});
var _hoisted_9 = {
  class: "text-hint"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ApplyBanner = _resolveComponent("ApplyBanner");
  var _component_a_divider = _resolveComponent("a-divider");
  var _component_ApplyForm = _resolveComponent("ApplyForm");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_ctx.applyService.item ? (_openBlock(), _createBlock(_component_ApplyBanner, {
    key: 0
  })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_a_divider, {
    style: {
      "margin": "16px 0 0"
    }
  }), _ctx.applyService.item ? (_openBlock(), _createBlock(_component_ApplyForm, {
    key: 0
  })) : _ctx.applyService.errorInfo ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.applyService.errorInfo.text), 1)])) : _createCommentVNode("", true)])])]);
}